type Status = 'Completed' | 'In Progress';

interface MinCostPerSquareFootVersionFriendlyViewSummaryParameters {
    id: number;
    description: string;
    status?: Status;
}

export default class MinCostPerSquareFootVersionFriendlyViewSummary {
    public id: number;
    public description: string;
    public status: Status | undefined;
    
    public constructor(params: MinCostPerSquareFootVersionFriendlyViewSummaryParameters) {
        this.id = params.id;
        this.description = params.description;
        this.status = params.status;
    }
}